// extracted by mini-css-extract-plugin
export default {"version":"VersionName-module__version--FC1cb"};